import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconDeactivate = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 21 20" fill="none">
    <path
      d="M15.9167 4.58331L5.08343 15.4164"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle
      cx="10.5001"
      cy="10"
      r="8.33333"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </SvgIcon>
)
